import React from 'react';

import {Form, FormControl, FormDescription, FormField, FormItem, FormLabel} from '@/components/ui/Form/Form';
import Switch from '@/components/ui/Switch/Switch';

const NotificationSettingsContent = ({form, sectionHeader, title, description, isPushNotificationDisabled}) => {
    const pushNotificationsSection = {
        header: sectionHeader,
        items: [
            {
                name: 'isNotificationEnabled',
                title,
                description,
            },
        ],
    };

    return (
        <Form {...form}>
            {[pushNotificationsSection].map((section, index) => (
                <section key={index} className='w-full px-4 pt-4 ml:px-0 '>
                    <h3 className='text-start text-20 font-bold tracking-02 md:px-0'>{section.header}</h3>
                    <fieldset className='mt-4 rounded-xl bg-romance px-4 ml:bg-primary-dark-5 ml:px-6'>
                        {section.items.map((item, i) => (
                            <React.Fragment key={i}>
                                <FormField
                                    control={form.control}
                                    name={item.name}
                                    render={({field}) => (
                                        <FormItem
                                            className='flex items-center justify-between border-b border-primary-dark-15 py-4 last:border-b-0 ml:py-6'
                                            key={i}
                                        >
                                            <div className='flex flex-col text-start'>
                                                <FormLabel className='text-14 font-bold tracking-02'>
                                                    {item.title}
                                                </FormLabel>
                                                <FormDescription className='text-14 font-normal tracking-04'>
                                                    {item.description}
                                                </FormDescription>
                                            </div>
                                            <FormControl>
                                                <Switch
                                                    checked={field.value}
                                                    onCheckedChange={field.onChange}
                                                    disabled={isPushNotificationDisabled}
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                            </React.Fragment>
                        ))}
                    </fieldset>
                </section>
            ))}
        </Form>
    );
};

export default NotificationSettingsContent;
